import React from 'react';
import { addTranslationKeys, t } from 'Src/i18n';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import type { MultimediaResources } from 'Components/widgets/multimedia/Multimedia';
import { Multimedia } from 'Components/widgets/multimedia/Multimedia';
type Props = {
  config: CMSContent;
  id: string;
  media: MultimediaResources;
  resort: {
    name: string;
  };
  title: string;
};
export const ProductMultimediaLine = ({
  config,
  id,
  media = {},
  resort: { name },
  title,
}: Props) => {
  const { photos, videos, videos360 } = media;
  addTranslationKeys(config);

  if (!photos?.length && !videos?.length && !videos360?.length) {
    return null;
  }

  const galleryLabel = name
    ? t('common.galleries.productGallery', {
        productName: name,
      })
    : t('common.galleries.gallery');
  const nextLabel = name
    ? t('common.galleries.productNextPicture', {
        productName: name,
      })
    : t('common.next');
  const previousLabel = name
    ? t('common.galleries.productPreviousPicture', {
        productName: name,
      })
    : t('common.previous');
  return (
    <SiteContainer className="Line" id={id}>
      <LineTitle>{title}</LineTitle>
      <Multimedia
        closeLabel={t('common.close')}
        galleryLabel={galleryLabel}
        labels={{
          photos: t('common.photoTitle'),
          videos: t('common.videoTitle'),
          videos360: t('common.video360Title'),
        }}
        launcherPictureAltLabel={t('common.galleries.openProductSlideShowGalleryAt', {
          productName: name,
        })}
        medias={media}
        nextLabel={nextLabel}
        openGalleryLabel={t('common.galleries.openSlideShowGallery')}
        pictureAltLabel={t('common.galleries.productPictureItem', {
          productName: name,
        })}
        previousLabel={previousLabel}
      />
    </SiteContainer>
  );
};
